import React, { memo } from 'react';
import TouchableBounce from 'utils/packages/TouchableBounce';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import Amount from './Amount';
import { rem } from './values';
const AmountPill = ({ value, style, onPress, currency, selected, showFraction = false, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<TouchableBounce onPress={onPress} style={[styles.btnStyle, selected && styles.activeBtn, style]}>
      <Amount value={{
            value,
            currency,
        }} Numbers-14 showFraction={showFraction} color={selected ? colors.text.textOnBrandLight : colors.text.secondary}/>
    </TouchableBounce>);
};
export default memo(AmountPill);
const styleSet = createStyleSheets((colors) => ({
    btnStyle: {
        height: rem(34),
        alignItems: 'center',
        borderRadius: rem(10),
        justifyContent: 'center',
        paddingHorizontal: rem(24),
        backgroundColor: colors.buttons.secondary,
    },
    activeBtn: {
        backgroundColor: colors.buttons.brandLight,
    },
}));
